const RTL_LANGUAGES = new Set(['ar', 'fa', 'he', 'ur']);

export function isRtlLanguage(lang: string): boolean {
  return RTL_LANGUAGES.has(lang);
}
